import http from '@/utils/ajax'
import { GENERAL_LEDGER_INIT_LOADING, GENERAL_LEDGER_INIT_SUCCESS, GENERAL_LEDGER_INIT_FAIL,
  FINANCIAL_YEAR_INIT_LOADING, FINANCIAL_YEAR_INIT_SUCCESS, FINANCIAL_YEAR_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  init: 0,
  initErr: [],
  menu: {},
  financialYear: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

const mutations = {
  [GENERAL_LEDGER_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [GENERAL_LEDGER_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [GENERAL_LEDGER_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [FINANCIAL_YEAR_INIT_LOADING](state) {
    state.financialYear.init = 0
    state.financialYear.initErr = []
    state.financialYear.menu = {}
  },
  [FINANCIAL_YEAR_INIT_SUCCESS](state, data) {
    state.financialYear.init = 1
    state.financialYear.initErr = []
    state.financialYear.menu = data.menu
  },
  [FINANCIAL_YEAR_INIT_FAIL](state, error) {
    state.financialYear.init = 2
    state.financialYear.initErr = error
    state.financialYear.menu = {}
  }
}

const getters = {
}

const actions = {
  async glManagementInit({ commit, rootState }) {
    commit(GENERAL_LEDGER_INIT_LOADING)
    const apiUrl = rootState.app.menu.generalLedger
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(GENERAL_LEDGER_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(GENERAL_LEDGER_INIT_FAIL, extractMessages(error))
    }
  },
  async financialYearInit({ commit, state }) {
    commit(FINANCIAL_YEAR_INIT_LOADING)
    const apiUrl = state.menu.financialYear
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      let commitResult = {
        menu: menu
      }
      commit(FINANCIAL_YEAR_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(FINANCIAL_YEAR_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
